<template>
  <div>
    <div class="modal-card" style="width: 900px; height: auto">
      <section class="modal-card-body">
        <b-notification :closable="false">
          <b-field :label="$t('compJobView.job-name')">
            <div class="content">{{ job.name }}</div>
          </b-field>
        </b-notification>

        <b-notification :closable="false">
          <b-field :label="$t('job-stdout')">
            <div class="content">{{ job.stdout }}</div>
          </b-field>
        </b-notification>

        <b-notification :closable="false">
          <b-field :label="$t('job-stderr')">
            <div class="content" style="overflow: scroll">{{ job.stderr }}</div>
          </b-field>
        </b-notification>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobsTable',
  props: {
    job: {
      type: Object,
      required: true
    }
  }
}
</script>
